import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {BASE_URL} from "../../app.environment";
import {SjcImageSearchResponse} from "../types/groups/responses";
import {SearchQuery} from "../types/groups/params";

@Injectable({
    providedIn: 'root'
})
export class SjcApiService {
    httpClient = inject(HttpClient)
    baseApiUrl = BASE_URL;

    constructor() {
    }

    search(body: SearchQuery): Observable<SjcImageSearchResponse> {
        return this.httpClient.post<SjcImageSearchResponse>(`${this.baseApiUrl}/img-search`, body);
    }
}
